export * from '@taqueria/protocol/out/types/ParsedTemplate';
